import { IMAGE_CONFIG } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { apiBaseUrlInterceptor } from './core/api-base-url.interceptor';
import { authenticationRequiredInterceptor } from './core/authentication-required.interceptor';
import { routes } from './app.routes';
import { AuthService } from './features/auth/auth.service';

function initializeProfileCurrency(authService: AuthService): () => Promise<void> {
  return async () => {
    try {
      await firstValueFrom(authService.syncProfileDefaultCurrency());
    } catch {
      // Guests and temporary profile failures should not block app startup.
    }
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptors([authenticationRequiredInterceptor, apiBaseUrlInterceptor])),
    provideRouter(routes),
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AuthService],
      useFactory: initializeProfileCurrency,
    },
    {
      provide: IMAGE_CONFIG,
      useValue: {
        disableImageSizeWarning: true,
        disableImageLazyLoadWarning: true,
      },
    },
  ]
};
